















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import UIPageExplorer from '@/components/designer/UIPageExplorer.vue';
import { TreeNode } from '@/libs/com/MetaPattern/Product/IDE/Util/TreeNode';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';

@Component({
  components: {
    UIPageExplorer
  }
})
export default class PGRowUIPageValue extends Vue {
  @Prop() private value!: string | BaseElement;
  @Prop() private app!: APP;
  @Prop() private isEditable!: boolean;
  private dialogVisible = false;
  private uiPage = '';
  private dataObj = null as BaseElement;

  selectPage(node: TreeNode<BaseElement>) {
    this.uiPage = node.nodeValue;
    this.dataObj = node.data;
  }

  get valueTitle() {
    if (this.value instanceof BaseElement) {
      return this.value.name;
    }
    return this.value;
  }

  set valueTitle(value: string | BaseElement) {
    this.value = value;
  }

  valueChanged(): void {
    if (this.uiPage === '') {
      this.$message({ type: 'warning', message: '请选择具体的页面!' });
    } else {
      this.dialogVisible = false;
      this.$emit('valueChanged', this.uiPage, this.dataObj);
    }
  }

  clearValue(): void {
    this.dialogVisible = false;
    this.uiPage = '';
    this.dataObj = null;
    this.$emit('valueChanged', this.uiPage, this.dataObj);
  }
}
